export default __webpack_public_path__ + "467a1e95defbb3bf2780a64b79d57b38.svg";